module.exports = __webpack_public_path__ + "static/media/IMG_1764.db7ea55a.JPG";